// extracted by mini-css-extract-plugin
export default {"modalWrapper":"_Modal_modalWrapper__ABiuF"};